import(/* webpackMode: "eager" */ "/codebuild/output/src1493512642/src/rmh-platform/apps/rmh-patient/app/error.tsx");
